/* GENERATED FILE */
import type { ReactElement } from "react";
import { Fragment } from "react";
import type { IconVariant } from "../lib";

export default new Map<IconVariant, ReactElement>([
	[
		"duocolor",
		<Fragment key={"duocolor"}>
			<path
				opacity="0.4"
				d="M21 19V8C21 7.07116 21 6.60674 20.9487 6.21684C20.5942 3.52444 18.4756 1.40579 15.7832 1.05133C15.3933 1 14.9288 1 14 1H10C8.34315 1 7 2.34315 7 4V4"
				stroke="currentColor"
				strokeWidth="1.5"
				strokeLinecap="round"
				strokeLinejoin="round"
			/>
			<path
				d="M18 22V10.4C18 8.15979 18 7.03969 17.564 6.18404C17.1805 5.43139 16.5686 4.81947 15.816 4.43597C14.9603 4 13.8402 4 11.6 4H10.4C8.15979 4 7.03969 4 6.18404 4.43597C5.43139 4.81947 4.81947 5.43139 4.43597 6.18404C4 7.03969 4 8.15979 4 10.4V22L6.23707 20.7217C7.97311 19.7297 8.84113 19.2336 9.76298 19.0394C10.5787 18.8675 11.4213 18.8675 12.237 19.0394C13.1589 19.2336 14.0269 19.7297 15.7629 20.7217L18 22Z"
				stroke="currentColor"
				strokeWidth="1.5"
				strokeLinecap="round"
				strokeLinejoin="round"
			/>
		</Fragment>,
	],
	[
		"duotone",
		<Fragment key={"duotone"}>
			<path
				opacity="0.12"
				d="M18 22V10.4C18 8.15979 18 7.03969 17.564 6.18404C17.1805 5.43139 16.5686 4.81947 15.816 4.43597C14.9603 4 13.8402 4 11.6 4H10.4C8.15979 4 7.03969 4 6.18404 4.43597C5.43139 4.81947 4.81947 5.43139 4.43597 6.18404C4 7.03969 4 8.15979 4 10.4V22L6.23707 20.7217C7.97311 19.7297 8.84113 19.2336 9.76298 19.0394C10.5787 18.8675 11.4213 18.8675 12.237 19.0394C13.1589 19.2336 14.0269 19.7297 15.7629 20.7217L18 22Z"
				fill="currentColor"
			/>
			<path
				d="M21 19V8C21 7.07116 21 6.60674 20.9487 6.21684C20.5942 3.52444 18.4756 1.40579 15.7832 1.05133C15.3933 1 14.9288 1 14 1H10C8.34315 1 7 2.34315 7 4V4M18 22V10.4C18 8.15979 18 7.03968 17.564 6.18404C17.1805 5.43139 16.5686 4.81947 15.816 4.43597C14.9603 4 13.8402 4 11.6 4H10.4C8.15979 4 7.03968 4 6.18404 4.43597C5.43139 4.81947 4.81947 5.43139 4.43597 6.18404C4 7.03968 4 8.15979 4 10.4V22L6.23707 20.7217C7.97311 19.7297 8.84113 19.2336 9.76298 19.0394C10.5787 18.8675 11.4213 18.8675 12.237 19.0394C13.1589 19.2336 14.0269 19.7297 15.7629 20.7217L18 22Z"
				stroke="currentColor"
				strokeWidth="1.5"
				strokeLinecap="round"
				strokeLinejoin="round"
			/>
		</Fragment>,
	],
	[
		"filled",
		<Fragment key={"filled"}>
			<path
				fillRule="evenodd"
				clipRule="evenodd"
				d="M12.4 0.249975L12.2666 0.249957C11.0925 0.249713 10.3445 0.249558 9.71066 0.428313C8.16234 0.864984 6.94329 2.05448 6.4658 3.5845C6.35923 3.62176 6.25653 3.66317 6.1567 3.70919C5.07554 4.20761 4.20771 5.07545 3.70928 6.1566C3.25 7.15287 3.25 8.43522 3.25 10.9999V21.9137C3.25 22.3664 3.25 22.5928 3.3451 22.7241C3.42806 22.8386 3.55561 22.9126 3.69619 22.9278C3.85734 22.9452 4.05386 22.8329 4.44691 22.6083L4.64942 22.4926L4.64944 22.4926C6.96415 21.1699 8.12151 20.5086 9.35065 20.2496C10.4383 20.0204 11.5617 20.0204 12.6494 20.2496C13.8785 20.5086 15.0359 21.1699 17.3506 22.4926L17.5531 22.6083C17.9461 22.8329 18.1427 22.9452 18.3038 22.9278C18.4444 22.9126 18.5719 22.8386 18.6549 22.7241C18.75 22.5928 18.75 22.3664 18.75 21.9137V10.9999C18.75 8.43521 18.75 7.15287 18.2907 6.1566C17.7923 5.07545 16.9245 4.20761 15.8433 3.70919C14.847 3.2499 13.5647 3.2499 11 3.2499C9.85092 3.2499 8.95925 3.2499 8.2354 3.29121C8.65758 2.60828 9.32454 2.09572 10.1178 1.872C10.5253 1.75707 11.047 1.74997 12.4 1.74997C14.4041 1.74997 15.2513 1.75707 15.9251 1.94708C17.6831 2.4429 19.0571 3.81687 19.5529 5.57491C19.7429 6.24864 19.75 7.09592 19.75 9.09998V19C19.75 19.4142 20.0858 19.75 20.5 19.75C20.9142 19.75 21.25 19.4142 21.25 19V9.09998L21.25 8.95253V8.95249C21.2502 7.13983 21.2503 6.06737 20.9966 5.16775C20.3591 2.90741 18.5926 1.14088 16.3322 0.503402C15.4326 0.249681 14.3601 0.249787 12.5474 0.249965L12.4 0.249975Z"
				fill="currentColor"
			/>
		</Fragment>,
	],
	[
		"gestalt",
		<Fragment key={"gestalt"}>
			<path
				d="M4 13V10.4C4 8.15979 4 7.03968 4.43597 6.18404C4.81947 5.43139 5.43139 4.81947 6.18404 4.43597C7.03968 4 8.15979 4 10.4 4H11.6C13.8402 4 14.9603 4 15.816 4.43597C16.5686 4.81947 17.1805 5.43139 17.564 6.18404C18 7.03968 18 8.15979 18 10.4V22L15.7629 20.7217C14.0269 19.7297 13.1589 19.2336 12.237 19.0394C11.4213 18.8675 10.5787 18.8675 9.76298 19.0394C8.84113 19.2336 7.97311 19.7297 6.23707 20.7217L4 22V17M21 19V8C21 7.07116 21 6.60674 20.9487 6.21684C20.5942 3.52444 18.4756 1.40579 15.7832 1.05133C15.3933 1 14.9288 1 14 1H10C8.34315 1 7 2.34315 7 4V4"
				stroke="currentColor"
				strokeWidth="1.5"
				strokeLinecap="round"
				strokeLinejoin="round"
			/>
		</Fragment>,
	],
	[
		"line",
		<Fragment key={"line"}>
			<path
				d="M21 19V8C21 7.07116 21 6.60674 20.9487 6.21684C20.5942 3.52444 18.4756 1.40579 15.7832 1.05133C15.3933 1 14.9288 1 14 1H10C8.34315 1 7 2.34315 7 4V4M18 22V10.4C18 8.15979 18 7.03968 17.564 6.18404C17.1805 5.43139 16.5686 4.81947 15.816 4.43597C14.9603 4 13.8402 4 11.6 4H10.4C8.15979 4 7.03968 4 6.18404 4.43597C5.43139 4.81947 4.81947 5.43139 4.43597 6.18404C4 7.03968 4 8.15979 4 10.4V22L6.23707 20.7217C7.97311 19.7297 8.84113 19.2336 9.76298 19.0394C10.5787 18.8675 11.4213 18.8675 12.237 19.0394C13.1589 19.2336 14.0269 19.7297 15.7629 20.7217L18 22Z"
				stroke="currentColor"
				strokeWidth="1.5"
				strokeLinecap="round"
				strokeLinejoin="round"
			/>
		</Fragment>,
	],
	[
		"mono",
		<Fragment key={"mono"}>
			<path
				opacity="0.32"
				d="M21 18.4V9.4C21 7.16646 21 6.04969 20.7063 5.1459C20.1128 3.31927 18.6807 1.88717 16.8541 1.29366C15.9503 1 14.8335 1 12.6 1C11.111 1 10.3665 1 9.76393 1.19577C8.54618 1.59145 7.59145 2.54618 7.19577 3.76393C7 4.36646 7 5.11097 7 6.6V8H17V17L19.72 19.04L19.72 19.04C20.132 19.349 20.338 19.5035 20.5104 19.4999C20.6604 19.4968 20.8012 19.4264 20.8937 19.3083C21 19.1725 21 18.915 21 18.4Z"
				fill="currentColor"
			/>
			<path
				d="M9.65 3.25C7.40979 3.25 6.28969 3.25 5.43404 3.68597C4.68139 4.06947 4.06947 4.68139 3.68597 5.43404C3.25 6.28969 3.25 7.40979 3.25 9.65001V21.9138C3.25 22.3665 3.25 22.5929 3.3451 22.7241C3.42806 22.8386 3.55561 22.9127 3.69619 22.9279C3.85734 22.9453 4.05386 22.833 4.44691 22.6084L4.64942 22.4927C6.96415 21.17 8.12151 20.5087 9.35065 20.2497C10.4383 20.0205 11.5617 20.0205 12.6494 20.2497C13.8785 20.5087 15.0359 21.17 17.3506 22.4927L17.5531 22.6084C17.9461 22.833 18.1427 22.9453 18.3038 22.9279C18.4444 22.9127 18.5719 22.8386 18.6549 22.7241C18.75 22.5929 18.75 22.3665 18.75 21.9138V9.65C18.75 7.40979 18.75 6.28969 18.314 5.43404C17.9305 4.68139 17.3186 4.06947 16.566 3.68597C15.7103 3.25 14.5902 3.25 12.35 3.25H9.65Z"
				fill="currentColor"
			/>
		</Fragment>,
	],
]);
